import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'checbox-component' ,
  templateUrl: 'checkboxComponent.html',
  styleUrls: ['checkboxComponent.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckboxComponent implements ViewCell, OnInit {
  @Input() value: any;
  @Output() changeCheckbox:  EventEmitter<number> = new EventEmitter();
  @Output() changeContextCheckbox:  EventEmitter<number> = new EventEmitter();
  rowData: any;
  isChecked = false;
  ngOnInit() {

  }

  onClick(event: MouseEvent) {
    event.stopPropagation();
  }

  async change(){
    await this.delay(100);
    this.changeCheckbox.emit(this.value);
  }

  changeContext(){
    this.changeContextCheckbox.emit(this.value.cell);
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
